<div #map class="map" [style]="{height}"></div>
<div class="map-loading" *ngIf="!isLoaded && !loadFailed" aria-live="polite">
  <p-skeleton width="100%" height="100%" styleClass="map-skeleton" borderRadius="4px"></p-skeleton>
</div>
<div class="map-error" *ngIf="loadFailed" role="alert">
  <span>{{ 'shared.map.loading_failed' | translate }}</span>
  <button type="button" (click)="retry()">{{ 'common.retry' | translate }}</button>
</div>
<a class="map-attribution" href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">
  {{ MAP_PROVIDER_CONFIG.attribution }}
</a>
